export class AdminNotification {
    todaysCertificateCounter: number;
    notificationMessage: string;
    pendingRequestCounter: number;
    activeDealerThisMonthCount: number;
    receivedDateTime: Date = new Date();
    notificationType: string;
    constructor(init?:Partial<AdminNotification>) {
        Object.assign(this, init);
    }
}

